
  <mat-card class="slidecontent">
    <div class="headcontent">
    
        <div class="pophead">
            <h3>Fax Document</h3>
              <mat-icon  class="close" (click)="closeShareOpt(closeShare)">close</mat-icon>
          </div>
        </div>
          <div class="dialog_content">

            <div class="documentListing">

              <ng-container *ngFor="let document of selectedFileList; let i = index">

              <div class="doc placeholder" *ngIf="!document.fileType">   
                <span class="type"> <mat-icon>backup</mat-icon> </span>
                <div class="name">
                  {{ getplaceholdername(document.name) }}
                </div>
                <button class="remove" mat-icon-button (click)="removeDocument(document)"><mat-icon>cancel</mat-icon></button>
              </div>

              <div class="doc" *ngIf="document.fileType">
                <span class="type" *ngIf="document.fileType == 'pdf' || document.fileType == '.pdf'">
                  <img src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                 </span>

                <span class="type" *ngIf="document.fileType == 'doc' ||
                    document.fileType == 'docx'">
                    <img src="../../../../../assets/icons/fileType/doc_icon.svg" alt="Word File"/>
                 </span>

                <span class="type" *ngIf="document.fileType == 'xlsx' ||
                    document.fileType == 'xls' ||
                    document.fileType == 'csv' ||
                    document.fileType == 'ods'">
                  <img src="../../../../../assets/icons/fileType/excel_icon.svg" alt="excel File"/>
                </span>
                <span class="type" *ngIf="document.fileType == 'jpg' ||
                    document.fileType == 'jpeg' || 
                    document.fileType == 'image/jpeg'">
                    <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'png' ||
                    document.fileType == 'gif' ||
                    document.fileType == 'tiff' ||
                    document.fileType == 'webp' ||
                    document.fileType == 'bmp'">
                    <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'txt'">
                  <img src="../../../../../assets/icons/fileType/text_icon.svg" alt="txt File"/>
                  </span>
                <span class="type" *ngIf="document.fileType == 'ppt' ||
                    document.fileType == 'pptx'">
                    <img src="../../../../../assets/icons/fileType/021-ppt.svg" alt="ppt File"/>
                  </span>               
                <div class="name">
                  {{ getplaceholdername(document.name) }}
                </div>
                <button class="remove" mat-icon-button (click)="removeDocument(document)"><mat-icon>cancel</mat-icon></button>
              </div>
              </ng-container>

             
            </div>

              <div class="fix-mat-form-field ">
               
                <mat-form-field  appearance="" class="mt-10 mb-10" style="position: relative;" >
                  <mat-label>Search contact or type fax</mat-label>
                  <input matInput
                         maxlength="15"
                         placeholder= "Type & Select"
                         aria-label="State"
                         [matAutocomplete]="auto" 
                         (input)="searchUser($event.target.value)"
                         [formControl]="stateCtrl"
                         id="stateCtrlid"                        
                         (keydown.enter)="onEnter($event,'')">
                   <mat-autocomplete #auto="matAutocomplete">
                    <mat-option (keydown.enter)="onEnter($event,contact)"
                    (click)="contactSelected(contact)" *ngFor="let contact of contactsList" [value]="contact.name">
                      <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
                          <div class="userpic">
                              <img *ngIf="contact.imageUrl!=''" src="{{contact.imageUrl}}" alt="">
                              <span class="username" *ngIf="contact.imageUrl==''" class="username">
                                  {{contact.shortName}}
                                </span>
                          </div>
                          <div class="info">
                            <p> {{ contact.name }}</p>
                            <p class="email" *ngIf="contact.fax">{{ contact.fax }}</p>
                            <p class="email" *ngIf="!contact.fax">No Fax Added</p>
                          </div> 
                      </span>
                    </mat-option>
                  </mat-autocomplete>
                  <button color="primary" *ngIf="addButtonShow" (click)="addcontact()"
                   mat-icon-button style="position: absolute; right: 0; top: -15px;">
                    <mat-icon>add</mat-icon>
                  </button>
                </mat-form-field>
                <ul  class="selectedlist">
                  <li *ngFor="let user of peoples">
                    <div class="userndetail">
                      <div class="userpic">
                        <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
                        <span *ngIf="user.img==''" class="username">
                          {{user.shortName}}
                        </span>
                      </div>
                      <div class="detail">
                        <h4>{{user.name}}</h4>
                        <p>{{user.fax}}</p>
                      </div>      
                        <div class="opt">
                            <button mat-icon-button><mat-icon (click)="removeContact(user)">cancel</mat-icon></button>
                        </div>
                    </div>
                  </li>
                </ul>

                <mat-form-field class="mt-10 ">
                  <mat-label>Add Subject</mat-label>
                  <!-- <input matInput placeholder="Type Subject"  [(ngModel)]="subject"> -->

                  <input matInput placeholder= "Add or select subject"
                  aria-label="State" [matAutocomplete]="auto1" 
                  (input)="searchSubject($event.target.value)"
                  [formControl]="stateCtrlSubject" [(ngModel)]="subject"
                  (keydown.enter)="onEnterSubject($event,'')">
                <mat-autocomplete #auto1="matAutocomplete">
                 <mat-option (click)="subjectSelected(subject)" *ngFor="let subject of subjectList" [value]="subject.subject">
                 <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">       
                  <div class="info">
                    <p> {{ subject.subject }}</p>          
                  </div> 
                 </span>
                </mat-option>
              </mat-autocomplete>

                </mat-form-field>

                  <mat-form-field>
                    <mat-label>Add Message</mat-label>
                    <textarea matInput placeholder="Add your fax message here..."
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="5"
                              [(ngModel)]="message" (input)="CheckMessage($event.target.value)">
                            </textarea>
                  </mat-form-field>
                  <mat-form-field class="mt-10 ">
                    <mat-label>Add Reply Fax Number</mat-label>
                    <input matInput placeholder="Type Reply Fax Number" (keypress)="allowOnlyNumber($event)" [(ngModel)]="replyFaxNumber" maxlength="15">
                  </mat-form-field>
                      
                  <button mat-button color="primary" *ngIf="ShowSubjectMessageButton" (click)="AddSubjectMessageTemplate()"
                  [disabled]="SubjectMessageButton">Add Template
                    <mat-icon *ngIf="spinnerTemp">
                      <mat-spinner diameter="20">
                      </mat-spinner>
                    </mat-icon>
                  </button>     

                </div>
      
          </div>
   
    
    <div class="actionBtn"> 
    <button mat-flat-button class="cancel" (click)="cancelShareOpt(closeShare)">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary"
    [disabled]="!showAddButton" (click)="sendFax()">Send
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
    </div>

</mat-card>




<div class="overlay" (click)="closeShareOpt(closeShare)"></div>


